import React, {Component} from 'react';
//import { withNavigation } from 'react-navigation'; // 画面遷移時に再描画するために必要 1/4

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

/*
class cMsgDtl extends React.Component {

    state = cf.myRN_crt_stss({
        s_cm10c310: '',
        s_newMsg: '',
        sld_msgss: [],
        sld_msgSubss: [],
        sld_filess: [],
        sn_maxMsgCnt: ic.gn_iniItemCnt,
        sb_showMdl: false,
    })

    componentDidMount() {
        cf.myRN_stt(this, ()=>{ // 画面遷移時に再描画するために必要 2/4
            if (global.c?.state.sgc_pageMode == 'show') {
                global.c?.load(true, 0)
            }
        });
    }

    componentWillUnmount() {
        cf.myRN_end(); // 画面遷移時に再描画するために必要 3/4
    }

    load = (pb_rld=true, pn_addMsgCnt=0) => {
        //
        cf.myRN_load([
            new Promise( _o_end1 => {
                //
                new Promise( _o_end2 => {
                    if (pb_rld) { // データを再度取り込み直す場合
                        //
                        // ★★★　cMsgList を使用しない場合　★★★
                        //cf.myRN_msg_get_grpKey('cm10', global.c?.state.sgcd_pagePntKeys.cm10_key)
                        //.then( _ct21_key => {
                        //    global.c?.setState({
                        //        sgc_pageKey: _ct21_key,
                        //    }, () =>{
                        //    })
                        //});
                        //
                        //
                        let _cnd = bf.q('[ct20b11k]="{}"'.f(global.c?.state.sgc_pageKey));
                        if (bf.f(global.c?.state.sgcd_schs.word)){ // 検索語が指定されている場合
                            _cnd += bf.q(' AND [ct20c610] LIKE "%{}%"'.f(global.c?.state.sgcd_schs.word)); 
                        };
                        cf.myCB_call_slc('nlm', 'ct20', 3, _cnd, '')
                        .then(async (_ld_ct20ss) => {
                            //
                            cf.myRN_msg_cnv_msg(_ld_ct20ss)
                            .then( _ld_itemss => {
                                global.c?.setState({
                                    sld_msgss: _ld_itemss
                                }, ()=>{
                                    _o_end2();
                                });
                            })
                            //
                            // 最終照会日時の更新 ※未読件数の更新は顧客検索画面・ホーム画面を表示した際に行う
                            cf.myRN_msg_upd_lastDtm(global.c?.state.sgc_pageKey, global.c?.state.sgc_cm10_key);
                        });
                    }
                    else {
                        _o_end2();
                    };
                })
                .then(()=>{
                    //
                    let _n_msgCnt = bf.myCM_get_len(global.c?.state.sld_msgss);
                    //
                    let _n_maxMsgCnt = global.c?.state.sn_maxMsgCnt + pn_addMsgCnt;
                    if (_n_maxMsgCnt < ic.gn_iniItemCnt) {
                        _n_maxMsgCnt = ic.gn_iniItemCnt;
                    };
                    if (_n_maxMsgCnt >= _n_msgCnt) {
                        _n_maxMsgCnt = _n_msgCnt;
                    };
                    global.c?.setState({
                        sn_maxMsgCnt: _n_maxMsgCnt,
                    }, ()=>{
                        //
                        let _i_end = _n_msgCnt;
                        if (_i_end < 0){
                            _i_end = 0;
                        }
                        let _i_stt = _i_end - _n_maxMsgCnt;
                        if (_i_stt < 0){
                            _i_stt = 0;
                        }
                        global.c?.setState({
                            sld_msgSubss: global.c?.state.sld_msgss,
                        }, () => {
                            _o_end1();
                        });
                    });
                });
            }),
        ]);
    };
    //
    render() {
        //
        return (
            <>
                <ce.RootDtl
                    key={-1}
                    crrPage='cMsgDtl'
                    d_hdrs={global.c?.state.sgcd_hdrs}
                    b_logo={false}
                    onSchEnt={()=>{
                        global.c?.load(true, 0);
                    }}
                    b_ste={true} 
                    onBdyScrTop={()=>{
                        global.c?.load(false, 10);
                    }}
                    b_rhtVsb={true}
                    rhtIconName='gear'
                    rhtPfx='設定'
                    onRhtPrs={() => {
                        let _d_pageInfs = {
                            sgc_pageRole: global.c?.state.sgc_pageRole,
                            sgc_pageName: 'cMsgSet',
                            sgc_pagePntKey: '',
                            sgc_pageKey: global.c?.state.sgc_pageKey,
                            sgc_pageMode: 'show',
                            sgc_pagePrc: '',
                        };
                        cf.myRN_move_fwd(_d_pageInfs);
                    }}
                    ld_bdyDefss={[
                        {
                            type: 'ListChat',
                            b_vsb: true,
                            state: 'sld_msgSubss',
                            b_chb: false,
                            b_prs: false,
                            b_avt: false,
                        },
                    ]}
                    n_btmH={((global.c?.state.sgcd_inpMsrs.h) ? global.c?.state.sgcd_inpMsrs.h : 72) + ic.gn_fontSizeNrm + ic.gn_mgnNrm * 5 + ic.gn_bdrWNrm * 2}
                    ld_btmDefss={[
                        {
                            type: 'Inp',
                            b_vsb: true,
                            b_edt: true,
                            state: 's_newMsg',
                            phd: 'メッセージを入力ください',
                            b_mln: true,
                            
                        },
                        {
                            type: 'Btns',
                            b_vsb: true,
                            ld_defss: [
                                {
                                    b_rvs: false,
                                    pfx: 'ファイル添付',
                                    onPrs: ()=>{
                                        global.c?.setState({
                                            sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                                                _next.pckFiles.b_showMdl = true;
                                            }),
                                        });
                                    },
                                    stlBtn: {
                                        width: ic.gn_btnWLrg,
                                    }
                                },
                                {
                                    b_rvs: false,
                                    pfx: '送る',
                                    onPrs: ()=>{
                                        if (global.c?.state.s_newMsg != '') {
                                            let _d_vals = {
                                                //ct20b11k: global.c?.state.sgcd_pagePntKeys.cm10_key, // お客様 am1d_key
                                                ct20b11k: global.c?.state.sgc_pageKey, // お客様 am1d_key
                                                ct20c110: '', // 送信番号
                                                ct20c410: '10', // 送信区分
                                                ct20c610: global.c?.state.s_newMsg, // 送信内容
                                                ct20cy10: bf.myDT_get_now(),
                                                ct20cy20: global.c?.state.sgc_cm10_key, // 送信者 am1d_key
                                                ct20cz10: '10',
                                            }
                                            cf.myCB_call_iud('ins', 'ct20', _d_vals, '', '')
                                            .then((_d_ct20s)=>{
                                                this.load(true, 1); // 追加分を表示
                                                global.c?.setState({
                                                    s_newMsg:''
                                                });
                                                //
                                            });
                                        };
                                    },
                                },
                            ], 
                        },
                    ]}
                />
                <ce.PckFilesMdl
                    key={-2}
                    o_this={global.c}
                />
            </>
        );
    }
}


export default withNavigation(cMsgDtl); // 戻るで再描画するために必要 4/4
*/
import cView from './cView';

export default class cMsgDtl extends cView {

  $id_stgs = { //  子で上書き
  };

  $cd_stss = { // 親を上書き
    sld_msgss: [],
    sld_msgSubss: [],
    sn_maxMsgCnt: 0,
    sld_filess: [],
//    sb_kbdAdj: false, // キーボードによる表示調整を行わない
  };


  $clp_loads = () => [ // 親を上書き
    new Promise( _o_end1 => {
      //
//      let _cnd = bf.q('[ct20b11k]="{}"'.f(global.c?.state.sgc_pageKey));
//      let _cnd = bf.q('[ct20b11k]="{}" AND ct'.f(global.c?.state.sgcd_pagePntKeys.ct21_key));
      let _cnd = bf.q('ct20b11k = "{}" AND IFNULL(ct20cz10,"10")<>"0"'.f(global.c?.state.sgcd_pagePntKeys.ct21_key));
      if (bf.f(global.c?.state.sgcd_schs.word)){ // 検索語が指定されている場合
        _cnd += bf.q(' AND [ct20c610] LIKE "%{}%"'.f(global.c?.state.sgcd_schs.word)); 
      };
      cf.myCB_call_slc({
        ctr: 'nlm', 
        elm: 'ct20', 
        n_dms: 3, 
        cnd: _cnd,
        })
      .then( _ld_ct20ss => {
//bf.l('248:{}, {}'.f(_cnd, _ld_ct20ss))
        //
        cf.myRN_msg_cnv_msg(_ld_ct20ss)
        .then( _ld_itemss => {
//bf.l('252:{}'.f(_ld_itemss))
          global.c?.setState({
            sld_msgss: _ld_itemss
          }, ()=>{
            _o_end1();
          });
        })
        //
        // 最終照会日時の更新 ※未読件数の更新は顧客検索画面・ホーム画面を表示した際に行う
//        cf.myRN_msg_upd_lastDtm(global.c?.state.sgc_pageKey, global.c?.state.sgc_cm10_key);
        cf.myRN_msg_upd_lastDtm(global.c?.state.sgcd_pagePntKeys.ct21_key, global.c?.state.sgc_cm10_key);
      });
    }),
  ];

  $cp_ins = () => new Promise( _o_end1 => {
  });

  $clp_upds = () => [ // 親を上書き
  ];

  _addMsgCnt = pn_addMsgCnt => new Promise( _o_end1 => {
    let _n_maxMsgCnt = global.c?.state.sn_maxMsgCnt + pn_addMsgCnt;

    if (_n_maxMsgCnt < ic.gn_iniItemCnt) {
      _n_maxMsgCnt = ic.gn_iniItemCnt;
    };

    let _n_msgCnt = bf.myCM_get_len(global.c?.state.sld_msgss);
    if (_n_maxMsgCnt >= _n_msgCnt) {
      _n_maxMsgCnt = _n_msgCnt;
    };

    if (global.c?.state.sn_maxMsgCnt != _n_maxMsgCnt) {
      global.c?.setState({
        sn_maxMsgCnt: _n_maxMsgCnt,
      }, () => {
        _o_end1();
      });
    }
    else {
      _o_end1();
    };
  });

  $pld_onChgss = () => [
    {
      o_eft: () => {
        //
        let _i_end = bf.myCM_get_len(global.c?.state.sld_msgss);
        if (_i_end < 0){
          _i_end = 0;
        }
        let _i_stt = _i_end - global.c?.state.sn_maxMsgCnt;
        if (_i_stt < 0){
          _i_stt = 0;
        }
        global.c?.setState({
          sld_msgSubss: global.c?.state.sld_msgss,
        }, ()=>{
//bf.l('306:{}'.f(global.c?.state.sld_msgss))
//bf.l('307:{}'.f(global.c?.state.sld_msgSubss))
        });
      },
      l_vals: [
        global.c?.state.sld_msgss,
        global.c?.state.sn_maxMsgCnt,
      ],
    },
  ];

  render() {
    //
    return (
      <this.$onChg>
        <ce.RootDtl
          key={-1}
          crrPage='cMsgDtl'
          d_hdrs={global.c?.state.sgcd_hdrs}
          b_logo={false}
          onSchEnt={()=>{
            global.c?.load(true, 0);
          }}
          b_ste={true} 
          onBdyScrTop={()=>{
            global.c?.load(false, 10);
          }}
          b_rhtVsb={true}
          rhtIconName='gear'
          rhtPfx='設定'
          onRhtPrs={() => {
            let _d_pageInfs = {
              sgc_pageRole: global.c?.state.sgc_pageRole,
              sgc_pageName: 'cMsgSet',
              sgc_pagePntKey: '',
              sgc_pageKey: global.c?.state.sgc_pageKey,
              sgc_pageMode: 'show',
              sgc_pagePrc: '',
            };
            cf.myRN_move_fwd(_d_pageInfs);
          }}
          ld_bdyDefss={[
            {
              type: 'ListChat',
              b_vsb: true,
              state: 'sld_msgSubss',
              b_chb: false,
              b_prs: false,
              b_avt: false,
            },
          ]}
          n_btmH={((global.c?.state.sgcd_inpMsrs.h) ? global.c?.state.sgcd_inpMsrs.h : 72) + ic.gn_fontSizeNrm + ic.gn_mgnNrm * 5 + ic.gn_bdrWNrm * 2}
          ld_btmDefss={[
            {
              type: 'Inp',
              b_vsb: true,
              b_edt: true,
              state: 's_newMsg',
              phd: 'メッセージを入力ください',
              b_mln: true,
            },
            {
              type: 'Btns',
              b_vsb: true,
              ld_defss: [
/*
                {
                  b_rvs: false,
                  pfx: 'ファイル添付',
                  onPrs: ()=>{
                    global.c?.setState({
                      sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                        _next.pckFiles.b_showMdl = true;
                      }),
                    });
                  },
                  stlBtn: {
                    width: ic.gn_btnWLrg,
                  }
                },
*/
                {
                  b_rvs: false,
                  pfx: '送る',
                  onPrs: ()=>{
                    if (global.c?.state.s_newMsg != '') {
                      let _d_vals = {
                        ct20b11k: global.c?.state.sgc_pageKey, // お客様 am1d_key
                        ct20c110: '', // 送信番号
                        ct20c410: '10', // 送信区分
                        ct20c610: global.c?.state.s_newMsg, // 送信内容
                        ct20cy10: bf.myDT_get_now(),
                        ct20cy20: global.c?.state.sgc_cm10_key, // 送信者 am1d_key
                        ct20cz10: '10',
                      }
                      cf.myCB_call_iud({
                        ctr: 'ins', 
                        elm: 'ct20', 
                        d_vals: _d_vals
                      })
                      .then((_d_ct20s)=>{
                        this.load(true, 1); // 追加分を表示
                        global.c?.setState({
                          s_newMsg:''
                        });
                        //
                      });
                    };
                  },
                },
              ], 
            },
          ]}
        />
        <ce.PckFilesMdl
          key={-2}
          o_this={global.c}
        />
      </this.$onChg>
    );
  }
}
